import React, { useCallback, useEffect, useState } from "react";
import api from "../../service/api";
import { Container, Content } from "./styles"; 
import iconBackArrow from "../../assets/icons/back-arrow-filled.svg";
import iconImport from "../../assets/icons/send.svg";
import iconEval from "../../assets/icons/eval.svg";
import { LibrasButtonMenu } from "../LibrasButtonMenu";
import {
  getAnimationByTokens,
} from "../../utils/animationHandle";
import LibrasIcon from "../../assets/icons/libras-icon.svg";
import { ClipLoader } from "react-spinners";
import arrowUpIcon from "../../assets/icons/arrow-up.svg";
import arowDownIcon from "../../assets/icons/arrow-down.svg";

interface Question {
  id: number;
  title: string;
  description: string;
  glosa: string;
}

interface CompleteChatProps {
  scenarioId?: number;
  scenarioName?: string;
  onBack: () => void;
  setAnimation: React.Dispatch<React.SetStateAction<any[]>>;
  onImportClick: () => void;
  onEvalClick: () => void;
}

export function CompleteChat({ scenarioId, scenarioName, onBack, setAnimation, onImportClick, onEvalClick }: CompleteChatProps) {
  const [questions, setQuestions] = useState<Question[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [isMobile, setIsMobile] = useState <boolean>(false);
  const [color] = useState("#ffffff");
  const [openedId, setOpenedId] = useState<number | null>(null);
  const [highlightedId, setHighlightedId] = useState<number | null>(null); 
  const [loadingLibrasId, setLoadingLibrasId] = useState<number | null>(null);

  async function fetchQuestions(id: number) {
    try {
      
      const response = await api.get(`/question/scenario/${id}`, {withCredentials: true});
      

      if (response.data && response.data.questions) {
        setQuestions(response.data.questions);
      } else {
        console.warn("Sem retorno da API.");
      }
    } catch (error) {
      
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    if (scenarioId) {
      fetchQuestions(scenarioId);
    }
  }, [scenarioId]);

  
  useEffect (()=> {
    const checkScreen =()=> {
      setIsMobile(window.innerWidth <769 )
    }
    checkScreen();
    window.addEventListener('resize',checkScreen)
    return ()=> window.removeEventListener('resize',checkScreen)  
  },[]);

  function handleBack(){
    onBack();
  }

  function toggleOpen(id: number) {
    setOpenedId(prev => (prev === id ? null : id));
  }

  function handleAnimationClick(e: React.MouseEvent<HTMLButtonElement, MouseEvent>, q: Question) {
    e.stopPropagation();
    handleAnimation(q);
  }

  function handleAnimation(q: Question){
    setLoadingLibrasId(q.id);

    const handleStarted = () => {
      setLoadingLibrasId(null);
      window.removeEventListener("LISA_ANIMATION_STARTED", handleStarted);
    };

    window.addEventListener("LISA_ANIMATION_STARTED", handleStarted);

    window.dispatchEvent(new CustomEvent("LISA_INTERRUPT"));

    setHighlightedId(q.id);

    getAnimationByTokens(q.glosa).then((animations) => {
      setAnimation(animations);
      window.dispatchEvent(new CustomEvent("LISA_RESUME"));
    }).catch(() => {
      handleStarted();
    });
  }

  const handleLibrasSelection = useCallback((detection: string) => {
    if (detection === 'voltar') {
      handleBack();
    } else if(!isNaN(parseInt(detection))) {
      const id = parseInt(detection)-1;
      if (id >= 0 && id < questions.length){
        const question = questions[id];
        handleAnimation(question);
      }
    }
  }, [questions]);

  useEffect(() => {
    const onLibrasEvent = (event: any) => {
      const num = event.detail.number;
      handleLibrasSelection(num);
    };

    window.addEventListener("LIBRAS_SELECTION", onLibrasEvent);

    return () => {
      window.removeEventListener("LIBRAS_SELECTION", onLibrasEvent);
    };
  }, [handleLibrasSelection]);
  

  return (
    <Container>
      {!isMobile && (
        <div className="CompleteChatHeader">
          <div className="backIcon icon" onClick={handleBack} tabIndex={3}>
            <img src={iconBackArrow} alt="Voltar" />
          </div>
          <div className="title">
            <span>{scenarioName}</span>
          </div>
          <div className="auxiliarIcons">
             <div className="evalIcon hint" data-hint="Avaliar"  data-hint-placement="bottom" onClick={onEvalClick} tabIndex={4}>
             <img src={iconEval} alt="Feedback" />
          </div>

          <div className="exportIcon hint" data-hint="Receber Email" data-hint-placement="bottom" onClick={onImportClick} tabIndex={5}>
            <img src={iconImport} alt="Exportar" />
          </div>
        </div>
        </div>
      )}

      <Content>
        { loading ? (
          <div className="CompleteChatLoading">
            {!isMobile && (
              <ClipLoader
              color={color}
              loading={loading}
              size={150}
              aria-label="Carregando..."
              data-testid="loader"
            />
            )}
            {isMobile && (
            <ClipLoader
              color={color}
              loading={loading}
              size={50}
              aria-label="Carregando..."
              data-testid="loader"
            />
            )}
          </div>
        ) : (
          <div className="QuestionsList" >
            {questions.map((q) => (
              <div
                onClick={() => toggleOpen(q.id)}
                onFocus={() => toggleOpen(q.id)}
                className={`QuestionItem ${highlightedId === q.id ? "QuestionItem--highlighted" : ""}`}
                key={q.id}
                style={ highlightedId === q.id ? { border: "2px solid #ffffff", borderRadius: 8 } : undefined }
              >
                <div className="QuestionTitle">
                  <h2>{q.title}</h2>
                    <div className="ButtonsTitle">
                      <div className="controls">
                        
                        <LibrasButtonMenu
                          disabled={loadingLibrasId === q.id}
                          onClick={(e) => {
                            handleAnimationClick(e, q);
                          }}
                        >
                          {loadingLibrasId === q.id ? (
                            <span className="btnSpinner" aria-label="Carregando" />
                          ) : (
                            <img src={LibrasIcon} alt="Ícone Libras" />
                          )}
                        </LibrasButtonMenu>

                        <img className="arrow-icon" src={openedId === q.id ? arrowUpIcon : arowDownIcon} alt="expandir"/>
                      </div>
                  </div>
                  
                </div>
                {openedId === q.id && (
                  <p className="description" dangerouslySetInnerHTML={{ __html: q.description }} />
                )}
              </div>
            ))}
           </div>
         )}
       </Content>
     </Container>
   );
 }
